import Request from "./index";

class api {
  // 获取区域简介详情
  static getAreaIntroduction(id) {
    return Request.get("/base/area/introduction/" + id);
  }

  // 获取区域设置信息
  static getAreaSetting(id) {
    return Request.get("/base/area/setting/" + id);
  }
}

export default api;
